import { Autocomplete, Grid, TextField } from "@mui/material"
import { ClasseSocialKeys, IClasseSocial } from "../../../../../../../application/models"
import { classeSocialKeyToLabel } from "../../../detalhes-do-projeto/filtros/classe-social"
import { useState, useEffect } from "react"
import { useRecortesExtracaoService } from "../../../../../../../use-cases/geo-veles"
import { useAppSelector } from "../../../../../../hooks/store-hooks"

export const RecorteClasseSocial = () => {
    const { editRecorteExtracaoForm } = useAppSelector((state) => state.recorteExtracao)
    const [selectedClasseSocial, setSelectedClasseSocial] = useState<IClasseSocial[]>([])
    const { syncFilterWithForm, removeFilterFromForm } = useRecortesExtracaoService()

    useEffect(() => {
        const classesSelecionadas = editRecorteExtracaoForm.fields.Filtros?.classeSocial || [];

        if (classesSelecionadas.length > 0) {
            setSelectedClasseSocial(classesSelecionadas);
        } else {
            setSelectedClasseSocial([]);
        }
    }, [editRecorteExtracaoForm.fields.Filtros?.classeSocial]);

    const filteredClasseSocial = ClasseSocialKeys.filter((classeSocial: IClasseSocial) =>
        !selectedClasseSocial.some((selected: IClasseSocial) => selected === classeSocial)
    );

  

    const handleClasseSocialSelectionChange = (value: IClasseSocial[]) => {
        setSelectedClasseSocial(value);

        if (value.length > 0) {
            syncFilterWithForm({
                filtro: 'classeSocial',
                value: value,
                formType: 'edit'
            });
        } else {
            removeFilterFromForm({
                filtro: 'classeSocial',
                formType: 'edit'
            });
        }
    }

    return (
        <>
            <Grid item xs={11} my={2}>
                <Autocomplete
                    multiple
                    id="tags-standard"
                    options={filteredClasseSocial}
                    getOptionLabel={(option) => classeSocialKeyToLabel(option).toUpperCase()}
                    sx={{ px: 2 }}
                    value={selectedClasseSocial}
                    onChange={(event, value) => {
                        handleClasseSocialSelectionChange(value);
                    }}
                    noOptionsText='Nenhuma classe social encontrada'
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="outlined"
                            label="Lista de Classes Sociais"
                        />
                    )}
                />
            </Grid>
        </>
    )
}